import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';
import global from '../../../common/utility/global';


import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {

    return (
        <CustomTable
            style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}

            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.idCuentasCobrarDetalle}
            columns={[
                {
                    title: 'Fecha Comprobante',
                    dataIndex: 'fechaStr',
                    key: 'fecha',
                    sorter: true
                },
                {
                    title: 'Nro Comprobante',
                    dataIndex: 'serieDocumentoComprobante',
                    key: 'comprobante',
                    sorter: true
                },
                {
                    title: 'Tipo Comprobante',
                    dataIndex: 'nombreTipoComprobante',
                    key: 'tipoComprobante',
                    sorter: true
                },
                {
                    title: 'Fecha Vencimiento',
                    dataIndex: 'fechaVencemientoStr',
                    key: 'fechaVencemientoStr',
                },
                {
                    title: 'Tipo Documento',
                    dataIndex: 'tipoDocumentoCliente',
                    key: 'tipoDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Nro Documento',
                    dataIndex: 'numeroDocumentoCliente',
                    key: 'numeroDocumentoCliente',
                    sorter: true
                },
                {
                    title: 'Proveedor',
                    dataIndex: 'razonSocialCliente',
                    key: 'razonSocialCliente',
                    sorter: true
                },
                {
                    title: 'Cuota',
                    dataIndex: 'cuota',
                    key: 'cuota',
                    sorter: true
                },
                {
                    title: 'Moneda Original',
                    dataIndex: 'moneda',
                    key: 'moneda',
                    sorter: true
                },
                {
                    title: 'Importe Cuota',
                    dataIndex: 'totalSoles',
                    key: 'totalSoles',
                    align: 'right',
                    render: (data) => (
                        <span>{data.toFixed(2)}</span>
                    )
                },
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambio',
                    key: 'tipoCambio',
                    render: (data) => (
                        <span>{data.toFixed(3)}</span>
                    )
                },

                {
                    title: 'Fecha Cobrado',
                    dataIndex: 'fechaPago',
                    key: 'fechaPago'

                },
                {
                    title: 'Metodo Pago',
                    dataIndex: 'metodoPago',
                    key: 'metodoPago'

                },
                {
                    title: 'Nro Operacion',
                    dataIndex: 'nroOperacion',
                    key: 'nroOperacion'

                },
                {
                    title: 'Monto Cobrado',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Soles',
                            dataIndex: 'canceladoSoles',
                            key: 'canceladoSoles',
                            className: 'child-group',
                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        },
                        {
                            title: 'Dólares',
                            dataIndex: 'canceladoDolares',
                            key: 'canceladoDolares',
                            className: 'child-group',
                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        }
                    ]
                },
                {
                    title: 'Banco',
                    dataIndex: 'banco',
                    key: 'banco'
                },
                {
                    title: 'Nro Cuenta',
                    dataIndex: 'cuenta',
                    key: 'cuenta'
                },
                {
                    title: 'Nro Doc. Referencia',
                    dataIndex: 'nroReferencia',
                    key: 'nroReferencia'
                }
            ]}
        />
    );
}